import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/shared/services/language.service';
import { NavigationService } from "../../shared/services/navigation.service";

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  private _mobile: boolean = false;
  private _opened: boolean = true;

  constructor(
    private navigationService: NavigationService,
    private languageService: LanguageService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.navigationService.opened.subscribe({
      next: res => {
        this._opened = res;
      }
    });
    this.breakpointObserver.observe([Breakpoints.HandsetPortrait]).subscribe({
      next: res => {
        this._mobile = res.matches;
        this.navigationService.setOpen(!this._mobile);
      }
    });
    this.router.events.subscribe({
      next: () => {
        if (this._mobile) {
          this.navigationService.setOpen(false);
        }
      }
    });
  }

  public get navItems() {
    return this.navigationService.navItems;
  }

  public get opened(): boolean {
    return this._opened || !this._mobile;
  }

  public set opened(value: boolean) {
    this.navigationService.setOpen(value);
  }

  public get mobile(): boolean {
    return this._mobile;
  }

  public get userName() {
    return this.navigationService.userName;
  }

  public get language() {
    return this.languageService;
  }
}
